module.exports = __webpack_public_path__ + "static/images/offer-empty.1UoU-Fb.svg";